import { render, staticRenderFns } from "./detailperson.vue?vue&type=template&id=0b4db48e&scoped=true"
import script from "./detailperson.vue?vue&type=script&lang=js"
export * from "./detailperson.vue?vue&type=script&lang=js"
import style0 from "./detailperson.vue?vue&type=style&index=0&id=0b4db48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4db48e",
  null
  
)

export default component.exports